"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _PublicationStages = _interopRequireDefault(require("playbooks-modal/constants/PublicationStages"));

var _PlaybookRecord = _interopRequireDefault(require("playbooks-modal/records/PlaybookRecord"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var _PlaybooksModalError = _interopRequireDefault(require("./PlaybooksModalError"));

var _PlaybookNotPublished = _interopRequireDefault(require("./PlaybookNotPublished"));

var _ReadOnlyEditor = _interopRequireDefault(require("./ReadOnlyEditor"));

var PlaybookBody = function PlaybookBody(_ref) {
  var isPreview = _ref.isPreview,
      playbook = _ref.playbook,
      editorState = _ref.editorState,
      fetchError = _ref.fetchError,
      propertiesFetching = _ref.propertiesFetching,
      configuredPlugins = _ref.configuredPlugins,
      onEditorStateChange = _ref.onEditorStateChange;

  if (fetchError) {
    return _react.default.createElement(_PlaybooksModalError.default, null);
  }

  if (!configuredPlugins || !playbook || propertiesFetching) {
    return _react.default.createElement(_UIFlex.default, {
      justify: "center",
      align: "center"
    }, _react.default.createElement(_UILoadingSpinner.default, {
      size: "medium",
      use: "success",
      style: {
        minHeight: 200
      }
    }));
  }

  var isPlaybookNotPublished = !isPreview && playbook.publicationStage === _PublicationStages.default.DRAFT;

  if (isPlaybookNotPublished) {
    return _react.default.createElement(_PlaybookNotPublished.default, null);
  }

  return _react.default.createElement(_ReadOnlyEditor.default, {
    title: playbook.title,
    editorState: editorState,
    configuredPlugins: configuredPlugins,
    onEditorStateChange: onEditorStateChange
  });
};

PlaybookBody.propTypes = {
  isPreview: _react.PropTypes.bool,
  playbook: _react.PropTypes.instanceOf(_PlaybookRecord.default),
  editorState: _react.PropTypes.object,
  fetchError: _react.PropTypes.bool.isRequired,
  propertiesFetching: _react.PropTypes.bool.isRequired,
  configuredPlugins: _react.PropTypes.func,
  onEditorStateChange: _react.PropTypes.func.isRequired
};
var _default = PlaybookBody;
exports.default = _default;
module.exports = exports.default;